import React, { useState, useEffect } from "react";

import {
  Stack,
  Card,
  CardBody,
  Select,
  Button,
  useDisclosure,
  Spinner,
} from "@chakra-ui/react";

import { GetSuppliers } from "services/SuppliersService";
import GetDates from "services/GetSupplierChangesDates";

import ModalNewCustomRequestViewComponent from "./component/ModalNewCustomRequestViewComponent";
import CustomRequestBreadcrumbConstant from "constants/BreadCrumbConstants/CustomRequestBreadcrumbConstant";

import check_icon from "../../assets/images/icons/check_icon.png";
import useDocumentTitle from "hooks/useDocumentTitle";
import PageDetailHeader from "components/PageDetailHeader/PageDetailHeader";
import formatDate from "utils/utils";
import AddCustomRequest from "services/CustomRequestService";
import data_not_found_blue_icon from "../../assets/images/icons/general_icons/data_not_found_blue_icon.png";

export default function NewRequestView() {
  useDocumentTitle("New Custom Request");
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [supplierList, setSupplierList] = useState([]);
  const [dateList, setDateList] = useState([]);

  const [selectedSupplier, setSelectedSupplier] = useState("");

  const [selectedFromDate, setSelectedFromDate] = useState("");
  const [selectedToDate, setSelectedToDate] = useState("");

  const [loadingSupplier, setLoadingSupplier] = useState(true);
  const [loadingDates, setLoadingDates] = useState(true);

  const [error, setError] = useState("");
  const [sendingRequest, setSendingRequest] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    if (
      selectedFromDate === "" ||
      selectedToDate === "" ||
      selectedSupplier === ""
    ) {
      setError("Please Select Correct Items");
      return;
    }

    if (selectedFromDate === selectedToDate) {
      setError("From Date should be not be the same as  To Date");
      return;
    }

    const fromDate = new Date(selectedFromDate);

    const toDate = new Date(selectedToDate);

    if (fromDate > toDate) {
      setError("From Date should be less than To Date");
      return;
    }

    setSendingRequest(true);

    try {
      const resp = await AddCustomRequest(formData);

      if (resp.status === 200) {
        onOpen();
        setError("");
      }
    } catch (error) {
      // console.log(error);
      setError("Server Error Occured");
    } finally {
      setSendingRequest(false);
    }
  };

  useEffect(() => {
    const fetchSupplierList = async () => {
      setLoadingSupplier(true);
      const response = await GetSuppliers();
      setSupplierList(response.data.data);
      setSelectedSupplier(response.data.data[0].supplier_id);
      setLoadingSupplier(false);
    };

    fetchSupplierList();
  }, []);

  useEffect(() => {
    // when selectedSupplier changes also resets the selectedDates
    setSelectedFromDate("");
    setSelectedToDate("");

    if (selectedSupplier === "") {
      return;
    }

    const fetchDateList = async () => {
      setLoadingDates(true);
      const response = await GetDates({ supplier_id: selectedSupplier });
      setDateList(response.data);
      setLoadingDates(false);

      if (response.data.length > 1) {
        setSelectedFromDate(response.data[1]);
        setSelectedToDate(response.data[0]);
      }
    };

    fetchDateList();
  }, [selectedSupplier]);

  return (
    <div className=" ">
      <ModalNewCustomRequestViewComponent isOpen={isOpen} onClose={onClose} />
      <Stack spacing={"2rem"}>
        <PageDetailHeader
          breadCrumbList={CustomRequestBreadcrumbConstant}
          heading="New Custom Request"
        />
        <div className="flex flex-row justify-center   ">
          <Card
            sx={{
              paddingTop: "2rem",
              px: "2rem",
              width: "fit-content",
              height: "fit-content",
              my: "auto",
            }}
          >
            <CardBody>
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="mb-2">
                  <div className="md:w-[33rem]">
                    <p className="label"> Select A Supplier</p>
                    {loadingSupplier && (
                      <div className="w-full h-10 flex flex-col justify-center ml-3 ">
                        <Spinner size="md" />
                      </div>
                    )}
                    {error && (
                      <p className="text-red-500 font-bold mb-2"> {error} </p>
                    )}
                    {!loadingSupplier && (
                      <Select
                        variant="outlineCustom"
                        name="supplier"
                        sx={{ height: "3.5rem", borderColor: "black" }}
                        value={selectedSupplier}
                        onChange={(e) => setSelectedSupplier(e.target.value)}
                      >
                        {supplierList?.map((supplier) => (
                          <option
                            key={supplier.supplier_id}
                            value={supplier.supplier_id}
                          >
                            {supplier.supplier_name}
                          </option>
                        ))}
                      </Select>
                    )}
                  </div>

                  {dateList.length <= 1 && !loadingDates && (
                    <>
                      <div className=" md:w-[33rem] mt-6">
                        <div className="my-auto flex flex-row justify-center gap-2 ">
                          <img src={data_not_found_blue_icon} />
                          <p>Data Not Found</p>
                        </div>
                      </div>
                    </>
                  )}

                  {(dateList.length > 1 || loadingDates) && (
                    <div className=" md:w-[33rem] mt-6">
                      <p className="label">Select Dates</p>
                      {loadingDates && (
                        <div className="w-full h-10 flex flex-col justify-center ml-3 ">
                          <Spinner size="md" />
                        </div>
                      )}
                      {!loadingDates && dateList.length > 1 && (
                        <div className="flex flex-row gap-5 justify-between mb-[3.5rem] ">
                          <div className="w-1/2">
                            <Select
                              variant="outlineCustom"
                              name="fromDate"
                              sx={{
                                height: "3.5rem",

                                borderColor: "black",
                              }}
                              value={selectedFromDate}
                              onChange={(e) =>
                                setSelectedFromDate(e.target.value)
                              }
                            >
                              {dateList?.map((date) => (
                                <option key={date} value={date}>
                                  {formatDate(date)}
                                </option>
                              ))}
                            </Select>
                          </div>
                          <div className="w-1/2">
                            <Select
                              variant="outlineCustom"
                              name="toDate"
                              sx={{
                                height: "3.5rem",

                                borderColor: "black",
                              }}
                              value={selectedToDate}
                              onChange={(e) =>
                                setSelectedToDate(e.target.value)
                              }
                            >
                              {dateList?.map((date) => (
                                <option key={date} value={date}>
                                  {formatDate(date)}
                                </option>
                              ))}
                            </Select>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="flex flex-row justify-end pt-[3rem] ">
                  <div className="w-[11.4rem]">
                    {(dateList.length > 1 || loadingDates) && (
                      <Button isDisabled={sendingRequest} type="submit">
                        {sendingRequest ? (
                          <>
                            <Spinner size={"sm"} />{" "}
                          </>
                        ) : (
                          <>
                            <img className="mr-2" src={check_icon} />
                            Submit Request
                          </>
                        )}
                      </Button>
                    )}
                  </div>
                </div>
              </form>
            </CardBody>
          </Card>
        </div>
      </Stack>
    </div>
  );
}
